import { render } from "./CostingRates.vue?vue&type=template&id=49c0ae2e"
import script from "./CostingRates.vue?vue&type=script&lang=js"
export * from "./CostingRates.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__